import { nodeName } from 'jquery';
import http from '../modules/api';
import axios from 'axios';
import React from 'react';
import ReactDOM from "react-dom";
// import ReactPixel from 'react-facebook-pixel';
import {ga4react, reactPixel} from '../Menu'
import '../../css/style.css';
import $ from 'jquery';
import * as Menu from '../Menu_v2';
import CommonPopup from '../modules/CommonPopup';
import { setCookie } from "../modules/utils/CookieUtil";

import icn_refresh from '../../resources/img/icn_refresh.svg';
import icn_refresh_spin from '../../resources/img/icn_refresh_spin.svg';
import { set } from 'date-fns';

import TitleContentDialogV2 from '../modules/dialogs/TitleContentDialogV2';
import WarningDialog from '../modules/dialogs/WarningDialog';
import SaveDialogV2 from '../modules/dialogs/SaveDialogV2';

// ReactPixel.init('438227415050093');
reactPixel.pageView();

var is_stroe_loaded = false;
var user_id = sessionStorage.getItem("user_id");
const naverCommerceTestUserIds = [
    "navercomercetest",
    "navercommercetest2"
];

const is_naver_commerce_test =
    naverCommerceTestUserIds.includes(sessionStorage.getItem("user_id"));

let is_test_use = "";
if (document.domain.indexOf("127.0.0.1") >= 0 || document.domain.indexOf("otdeal.me") >= 0) {
    is_test_use = "&is_test_use=Y"
}

const urlParams = new URLSearchParams(window.location.search);

/**
 * 사용자 서비스 - 상점추가 페이지
 */
export class SolutionStoreAdd_v2 extends React.Component {
  state = {
    service_type: urlParams.get('service_type'),
    
    step: 0,
    solution_type_cd: '',
    solution_name: '',
    agree_yn: '' /* 디폴트 값  변경 'N' -> '' */,
    mall_id: '',
    makeshop: {
      /*메이크샵 연동을 위한 필수 정보 입력 (국적, 화폐단위, 샵 이름을 받아야 할까..)*/
      shop_key: '',
      domain: '',
      shop_name: '',
      language_code: 'ko_KR' /*언어 코드 : (기본)국문*/,
    },
    imweb: {
      api_key: '',
      secret_key: '',
      domain: '',
      shop_name: '',
      language_code: '',
    },
    godomall: {
      id: '',
      domain: '',
      shop_name: '',
      language_code: '',
    },
    shops: [] /*cafe24 api에서 가져온 shop 리스트*/,
    options: {
      support_solution: [] /*code : 지원 플랫폼*/,
      language_code_list: [
        { cd_code: '-', cd_desc: '없음' },
        { cd_code: 'ko_KR', cd_desc: '국문' },
        { cd_code: 'en_US', cd_desc: '영문' },
        { cd_code: 'zh_CN', cd_desc: '중문(간체)' },
        { cd_code: 'zh_TW', cd_desc: '중문(번체)' },
        { cd_code: 'ja_JP', cd_desc: '일문' },
        { cd_code: 'vi_VN', cd_desc: '베트남어' },
      ],
    },

    is_registering_unlinked: false,
    warning_dialog_show_state: false,
    warning_dialog_content: "",
    warning_dialog_button_list: [{title:"확인", event_method:()=>{this.setState({warning_dialog_show_state:false})}}],
  };

  // 등록 요청 중 중복 클릭으로 같은 API가 여러 번 호출되지 않도록 합니다.
  isUnlinkedRegistrationPending = false;

  resetUnlinkedRegistration = () => {
    this.isUnlinkedRegistrationPending = false;
    this.setState({ is_registering_unlinked: false });
  };

  //공통코드 조회
  async getCode(upper_code_cd, option) {
    const res = await http.get(
      '/rest/common/cafe24Code?upper_code_cd=' + upper_code_cd + is_test_use,
    );
    const { options } = this.state;
    let codeData = res.data;

    // 네이버 커머스(09005)는 지정된 테스트 세션에서만 노출합니다.
    if (option == 'support_solution' && !is_naver_commerce_test && Array.isArray(codeData)) {
      codeData = codeData.filter((solution) => solution.code_cd != '09005');
    }

    this.setState({
      options: {
        ...options,
        [option]: codeData,
      },
    });
  }

  // 1단계 : 플랫폼 선택
  selectSolution = (e, code_cd, code_name) => {
    this.setState({
      solution_type_cd: code_cd,
      solution_name: code_name,
    });

    // 1. 전체
    $('.solutionBox').css({'background-color':'rgb(255, 255, 255)','box-shadow':'0 0 8px 2px rgba(0, 0, 0, 0.04)'});

    if(e.target.style.backgroundColor == 'rgb(255, 255, 255)') {
      e.target.style.backgroundColor = 'rgb(174, 243, 242)';
    }
    else {
      e.target.style.backgroundColor = 'rgb(255, 255, 255)';
    }
  };

  // 리사이징
  // resizing() {
  //   let thisBox = document.getElementsByClassName("solutionBox");
  //   let thisBoxArr = this.state.options.support_solution.length;
  //   if(window.innerWidth <= 800) {
  //     for(let i = 0; i < thisBoxArr; i++) {
  //       console.log(thisBox[i]);
  //       thisBox[i].style.height = thisBox[i].offsetWidth * 0.42 + "px";
  //     }
  //   }
  // }

  // 다음 단계
  nextStep = async () => {
    // alert(this.state.solution_name + "을 선택하셨습니다.");
    // if (this.state.step == 2 && this.state.agree_yn == 'N') {
    // 	alert("계정 정보 확인에 동의를 해주십시오.");
    // 	return false;
    // }

    // $('#step' + this.state.step + ' .radio').addClass('on');
    // $('#step' + this.state.step + ' .radio').css('font-size', '0px');
    if (Number(this.state.step) == 1) {
      //this.state.solution_type_cd = "09004" // 샘플 고도몰 코드
      if (this.state.solution_type_cd == '') {
        alert('플랫폼을 선택해 주세요.');
        return false;
      }
    }

    // 일반 비즈니스 / 개인(09900)과 기타 플랫폼(09999)은 동일한 비연동형 서비스로 등록합니다.
    const isUnlinkedService = this.state.solution_type_cd == '09900' || this.state.solution_type_cd == '09999';
    if (isUnlinkedService) {
      if (this.isUnlinkedRegistrationPending) return false;
      this.isUnlinkedRegistrationPending = true;
      this.setState({ is_registering_unlinked: true });
    } else {
      this.setState({
        step: Number(this.state.step) + 1,
      });
    }

    if (isUnlinkedService) {
      if (this.state.service_type == '01001') {
        this.fn_uninstall_01001_setting();
      } else if (this.state.service_type == '01013' || this.state.service_type == '01014' || this.state.service_type == '01015') {
        this.onClickShopActiveServiceButton(this.state.service_type, "Y");
      } else {
        this.fn_uninstall_01001_setting();
      }
    }
    // else if (this.state.solution_type_cd == '09003') { // 아임웹 
    //   alert('아이웹 관리자에 로보MD 앱을 설치하기 위해, 앱스토어로 이동합니다.');
    //   this.setState({ step: 1 });
    //   window.open("앱스토어 URL", '_blank');
    // }

    ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 플랫폼 선택', '쇼핑몰 플랫폼 선택 ID=' + user_id, '쇼핑몰 데이터 불러오기');
    reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 플랫폼 선택', {user_id : user_id});
  };

  handleMallIdOnBlur = () => {
    ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 ID 입력', '쇼핑몰 ID 입력 ID=' + user_id, '쇼핑몰 데이터 불러오기');
    reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 ID 입력', {user_id : user_id});
  }

  // 2단계 : 동의
  onClickAgree = (e, value) => {
    // $(".radio_display_yn:checked").prop("checked", false);
    // $("#display_"+e.target.value).prop("checked", true);
    this.setState({ agree_yn: value });

    ga4react.event('[쇼핑몰 데이터 불러오기] 계정 정보 확인 동의', '계정 정보 확인 동의 ID=' + user_id, '쇼핑몰 데이터 불러오기');
    reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 계정 정보 확인 동의', {user_id : user_id});
  };

  /**
   * 2단계 : mode에 따른 "플랫폼별 상점 가져오기" 기능의 버튼
   *
   * 1. [Cafe24 API] 상점 동기화
   *   mode : '/cafe24_sync_data'
   *
   * 2. 메이크샵 상점 연동에 필요한 데이터 저장
   *   mode : 'makeshop'
   *
   * 3. 아임웹
   *   mode : 'imweb'
   */
  onClickGetStoreInfoButton(mode) {
    if (this.state.step == 2 && this.state.agree_yn != 'Y') {
      alert('계정 정보 확인에 동의를 해주십시오.');
      return false;
    }
    ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 버튼 클릭', '쇼핑몰 데이터 불러오기 버튼 클릭 ID=' + user_id, '쇼핑몰 데이터 불러오기');
    reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 버튼 클릭', {user_id : user_id});

    /**
     * 1. 입력받은 상점키 : 저장 및 조회 (해당 계정으로 연동된 멀티샵 리스트 조회)
     * 2. 저장 후 연동된 리스트(체크박스 리스트) 조회
     * 3. 연동할 샵 선택후 저장
     * 4. 연동현황(전체) 조회
     */

    //1. [Cafe24 API] 상점 동기화
    if (mode == '/cafe24_sync_data') {
      var mall_id = this.state.mall_id;
      var solution_type_cd = this.state.solution_type_cd;

      if (mall_id == null || mall_id == '') {
        // 가입신청 - Cafe24 API] 상점 동기화
        // ReactGA.event({
        //     category: "[Cafe24 API] 상점 동기화",
        //     action: "상점 아이디를 입력해 주세요. : " + mall_id,
        //     label: ga_label
        // });
        alert('쇼핑몰 아이디를 입력해 주세요.');
        return false;
      }

      // mall_id 중복체크 추가
      http
        .get('/rest/common/storeCnt?mall_id=' + this.state.mall_id)
        .then((res) => {
          const { data } = res;
          if (data.storeCnt != null) {
            if (Number(data.storeCnt) == 0) {
              let called = false;
              let url = mode + '.html?mall_id='+mall_id+'&client_id='+data.client_id;
              var g_oWindow = window.open('about:blank', '_blank');
              if (g_oWindow != null) {
                called = this.fn_asyncCall(g_oWindow, url);
                console.log('called : ', called);

                // 0.5초 마다 감지
                var g_oInterval = window.setInterval(() => {
                  try {
                    // 창이 꺼졌는지 판단
                    console.log('g_oWindow.closed : ' + g_oWindow.closed);
                    if (g_oWindow == null || g_oWindow.closed) {
                      window.clearInterval(g_oInterval);
                      g_oWindow = null;
                      //this.selectShops(mall_id, solution_type_cd);
                      //window.location.href = "/shop/serviceShopAdd";
                      window.location.href = "/shop/serviceShopList";
                      //$("#mall_id").attr('disabled', true);
                    }
                  } catch (e) {
                    alert(e + '\n관리자에게 문의해 주세요. (1599-3518)');
                    //this.selectShops(mall_id, solution_type_cd);
                  }
                }, 500);
                // g_oWindow.addEventListener("beforeunload", function (event) {
                // 	event.returnValue = "asdasdasd?"
                // 	// console.log("close");
                // 	// this.selectShops(mall_id, solution_type_cd);
                // });
              }

            } else {
              ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', '쇼핑몰 데이터 불러오기 실패 ID=' + user_id, '쇼핑몰 데이터 불러오기');
              reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', {user_id : user_id});
              alert('이미 사용중인 쇼핑몰 ID 입니다.');
            }
          } else {
            ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', '쇼핑몰 데이터 불러오기 실패 ID=' + user_id, '쇼핑몰 데이터 불러오기');
            reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', {user_id : user_id});
            alert('시스템 점검중 입니다.');
          }
        })
        .catch((error) => {
          ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', '쇼핑몰 데이터 불러오기 실패 ID=' + user_id, '쇼핑몰 데이터 불러오기');
          reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', {user_id : user_id});
          alert(error + '\n관리자에게 문의해 주세요. (1599-3518)');
        });

      // Cafe24 로그인 팝업창 열기
      // var g_oWindow = window.open(mode+".html?mall_id="+mall_id, "카페24 데이터 동기화");

      // 가입신청 - Cafe24 API] 상점 동기화
      // ReactGA.event({
      //     category: "[Cafe24 API] 상점 동기화",
      //     action: "동기화 로그인 요청 : " + mall_id,
      //     label: ga_label
      // });
    } else if (mode == 'naver_commerce') {
      this.startNaverCommerceIntegration();
      return;
    } else if (mode == 'makeshop') {
      var solution_type_cd = this.state.solution_type_cd;
      var shop_key = this.state.makeshop.shop_key;
      var domain = this.state.makeshop.domain.replace(
        /(https?:\/\/)?((\/[^\s/\/]+)*)?(\?([^#\s]*))?/gi,
        '',
      ); //도메인 추출 (프로토콜, 하위경로, 파라미터 제거)
      //var mall_id = this.state.makeshop.shop_name; // **** cafe24 외의 플랫폼은 shop_name을 mall_id로 대체
      var shop_name = this.state.makeshop.shop_name;
      var language_code = this.state.makeshop.language_code;

      let data = {
        //mall_id: mall_id,
        shop_key: shop_key,
        solution_type_cd: solution_type_cd,
        domain: domain,
        shop_name: shop_name,
        language_code: language_code,
      };

      const config = {
        headers: {
          'content-type': 'application/json;',
        },
      };

      // 1. 입력받은 상점키 : 저장 및 조회 (해당 계정으로 연동된 MakeShop 리스트 조회)
      http
        .post('/rest/common/makeshop/shopAdd', data, config)
        .then((res) => {
          const { data } = res;
          if (data.code == 200) {
            // 2. 저장 후 연동된 리스트(체크박스 리스트) 조회
            //this.selectShops(data.mall_id, solution_type_cd);
            //window.location.href = "/shop/serviceShopAdd";
            window.location.href = "/shop/serviceShopList";
            console.log(res.data);

            ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 완료', '쇼핑몰 데이터 불러오기 완료 ID=' + user_id, '쇼핑몰 데이터 불러오기');
            reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 완료', {user_id : user_id});

          } else if (data.code == "-1") {
            ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', '쇼핑몰 데이터 불러오기 실패 ID=' + user_id, '쇼핑몰 데이터 불러오기');
            reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', {user_id : user_id});

            alert("도메인 정보가 일치하지 않습니다."+ '\n' +'[code : ' + data.code + ']' + '\n' + data.msg);

          } else if (data.code == "500") {
            ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', '쇼핑몰 데이터 불러오기 실패 ID=' + user_id, '쇼핑몰 데이터 불러오기');
            reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', {user_id : user_id});

            alert(
              '[code : ' +
                500 +
                ']' +
                '\n관리자에게 문의해 주세요. (1599-3518)',
            );
          } else {
            ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', '쇼핑몰 데이터 불러오기 실패 ID=' + user_id, '쇼핑몰 데이터 불러오기');
            reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', {user_id : user_id});

            alert('[code : ' + data.code + ']' + '\n' + data.msg);
          }
        })
        .catch((error) => {
          ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', '쇼핑몰 데이터 불러오기 실패 ID=' + user_id, '쇼핑몰 데이터 불러오기');
          reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', {user_id : user_id});

          alert(error + '\n관리자에게 문의해 주세요. (1599-3518)');
        });

    } else if (mode == 'imweb') {
      var solution_type_cd = this.state.solution_type_cd;
      var api_key = this.state.imweb.api_key;
      var secret_key = this.state.imweb.secret_key;
      var domain = this.state.imweb.domain.replace(
        /(https?:\/\/)?((\/[^\s/\/]+)*)?(\?([^#\s]*))?/gi,
        '',
      ); //도메인 추출 (프로토콜, 하위경로, 파라미터 제거)
      //var mall_id = this.state.imweb.shop_name;     // cafe24 외의 플랫폼은 shop_name을 mall_id로 대체 -> user_id_shop_no 조합으로 대체
      var shop_name = this.state.imweb.shop_name;
      var language_code = this.state.imweb.language_code;

      console.log(domain);

      let data = {
        //mall_id: mall_id,
        api_key: api_key,
        secret_key: secret_key,
        solution_type_cd: solution_type_cd,
        domain: domain,
        shop_name: shop_name,
        language_code: language_code,
      };

      const config = {
        headers: {
          'content-type': 'application/json;',
        },
      };
      // 1. 입력받은 상점키 : 저장 및 조회 (해당 계정으로 연동된 MakeShop 리스트 조회)
      http
        .post('/rest/common/imweb/shopAdd', data, config)
        .then((res) => {
          const { data } = res;
          if (data.code == 200) {
            // 2. 저장 후 연동된 리스트(체크박스 리스트) 조회
            //this.selectShops(data.mall_id, solution_type_cd);
            //window.location.href = "/shop/serviceShopAdd";
            window.location.href = "/shop/serviceShopList";
            console.log(res.data);

            ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 완료', '쇼핑몰 데이터 불러오기 완료 ID=' + user_id, '쇼핑몰 데이터 불러오기');
            reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 완료', {user_id : user_id});

          } else if (data.code == -1) {
            ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', '쇼핑몰 데이터 불러오기 실패 ID=' + user_id, '쇼핑몰 데이터 불러오기');
            reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', {user_id : user_id});

            alert("API KEY 또는 SECRET KEY 정보가 일치하지 않습니다."+ '\n' +'[code : ' + data.code + ']' + '\n' + data.msg);

          } else if (data.code == 401) {
            ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', '쇼핑몰 데이터 불러오기 실패 ID=' + user_id, '쇼핑몰 데이터 불러오기');
            reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', {user_id : user_id});

            alert('[code : ' + data.code + ']' + '\n' + data.msg);

          } else if (data.code == 500) {
            ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', '쇼핑몰 데이터 불러오기 실패 ID=' + user_id, '쇼핑몰 데이터 불러오기');
            reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', {user_id : user_id});

            alert(
              '[code : ' +
                data.code +
                ']' +
                '\n관리자에게 문의해 주세요. (1599-3518)',
            );
          }
        })
        .catch((error) => {
          ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', '쇼핑몰 데이터 불러오기 실패 ID=' + user_id, '쇼핑몰 데이터 불러오기');
          reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', {user_id : user_id});

          alert(error + '\n관리자에게 문의해 주세요. (1599-3518)');
        });
    } else if (mode == 'godomall') {
      // godomall: {
      //   id: '',
      //   domain: '',
      //   shop_name: '',
      //   language_code: '',
      // },

      var solution_type_cd = this.state.solution_type_cd;
      var id = this.state.godomall.id;
      var domain = this.state.godomall.domain.replace(
        /(https?:\/\/)?((\/[^\s/\/]+)*)?(\?([^#\s]*))?/gi,
        '',
      ); //도메인 추출 (프로토콜, 하위경로, 파라미터 제거)
      var shop_name = this.state.godomall.shop_name;
      var language_code = this.state.godomall.language_code;

      let data = {
        id: id,
        solution_type_cd: solution_type_cd,
        domain: domain,
        shop_name: shop_name,
        language_code: language_code,
      };

      const config = {
        headers: {
          'content-type': 'application/json;',
        },
      };
      // 1. 입력받은 고도몰 정보 : 저장 및 조회
      http
        .post('/rest/common/godomall/shopAdd', data, config)
        .then((res) => {
          const { data } = res;
          if (data.code == 200) {
            // 2. 저장 후 연동된 리스트(체크박스 리스트) 조회
            alert("신청이 완료되었습니다.\n관리자에게 상점키 입력을 요청해 주세요.\n(1599-3518)");
            //this.selectShops(data.mall_id, solution_type_cd);
            //window.location.href = "/shop/serviceShopAdd";
            window.location.href = "/shop/serviceShopList";
            console.log(res.data);

            ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 완료', '쇼핑몰 데이터 불러오기 완료 ID=' + user_id, '쇼핑몰 데이터 불러오기');
            reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 완료', {user_id : user_id});

          } else if (data.code == 500) {
            ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', '쇼핑몰 데이터 불러오기 실패 ID=' + user_id, '쇼핑몰 데이터 불러오기');
            reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', {user_id : user_id});

            alert(
              '[code : ' +
                data.code +
                ']' +
                '\n관리자에게 문의해 주세요. (1599-3518)',
            );
          }
        })
        .catch((error) => {
          ga4react.event('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', '쇼핑몰 데이터 불러오기 실패 ID=' + user_id, '쇼핑몰 데이터 불러오기');
          reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 쇼핑몰 데이터 불러오기 실패', {user_id : user_id});

          alert(error + '\n관리자에게 문의해 주세요. (1599-3518)');
        });

    } else {
      alert('[기타 플랫폼] 곧 찾아 뵙겠습니다.');
    }
  }

  /**
   * 비연동형 배너 서비스 데이터 세팅
   */
  fn_uninstall_01001_setting() {
    let data = {};
    const config = {
      headers: {
        'content-type': 'application/json;',
      },
    };
    http.post('/rest/shop/uninstall/shopAdd/01001', data, config)
        .then((res) => {
          const { data } = res;
          if (data.code == "200") {
            setCookie("solution_type_cd", "09900");
            window.location.href = "/shop/cafe24/event/list";
            //window.location.href = "/";

            ga4react.event('[쇼핑몰 데이터 불러오기] 비연동형 배너 서비스 세팅 완료', '비연동형 배너 서비스 세팅 완료 ID=' + user_id, '쇼핑몰 데이터 불러오기');
            reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 비연동형 배너 서비스 세팅 완료', {user_id : user_id});
          } else {
            this.resetUnlinkedRegistration();
            ga4react.event('[쇼핑몰 데이터 불러오기] 비연동형 배너 서비스 세팅 실패', '비연동형 배너 서비스 세팅 실패 ID=' + user_id, '쇼핑몰 데이터 불러오기');
            reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 비연동형 배너 서비스 세팅 실패', {user_id : user_id});
            alert(
              '[code : ' + data.code +'] ' + data.msg
              // + '\n관리자에게 문의해 주세요. (1599-3518)',
            );
          }
        })
        .catch((error) => {
          this.resetUnlinkedRegistration();
          ga4react.event('[쇼핑몰 데이터 불러오기] 비연동형 배너 서비스 세팅 실패', '비연동형 배너 서비스 세팅 ID=' + user_id, '쇼핑몰 데이터 불러오기');
          reactPixel.trackCustom('[쇼핑몰 데이터 불러오기] 비연동형 배너 서비스 세팅 실패', {user_id : user_id});
          alert(error + '\n관리자에게 문의해 주세요. (1599-3518)');
        });
  }
  
  shopActiveService = async (service_type) => {
    let shopData = {
    // solution_type_cd: solution_type_cd,
    // shop_no: shop_no,
    service_type: service_type
    }
    const config = {
    headers: {
        'content-type': 'application/json;',
    },
    };
    await axios.post('/rest/shop/activeService', shopData, config);
  }

  onClickShopActiveServiceButton(service_type, is_uninstall_yn) {
      let data = {
          service_type: service_type,
          is_uninstall_yn: is_uninstall_yn
      };
      const config = {
          headers: {
              'content-type': 'application/json;',
          },
      };
      // 1단계 : 무료로 이용하기 (사용자 서비스 추가, 권한 생성)
      http
      .post('/rest/shop/activeUserServiceSave', data, config)
      .then((res) => {
          const { data } = res;
          if (data.code == "200") {
              // 서비스 추가
              this.shopActiveService(service_type);
  
              // 페이지로 이동
              setTimeout(
              () => {
                if (is_uninstall_yn == 'Y') setCookie("solution_type_cd", "09900");

                if (service_type == '01001') {
                  window.location.href = '/shop/cafe24/main';
                }      
                else if (service_type == '01013') {
                  window.location.href = '/shop/productDesign/list';
                }
                else if (service_type == '01014') {
                  window.location.href = '/shop/instagram/InstagramAutoManageHome';
                }
                else if (service_type == '01015') {
                  window.location.href = '/shop/genAi/swaggerGenAi';
                }
              }, 500);
          } else {
              this.resetUnlinkedRegistration();
              alert(
                  '[code : ' +
                  data.code +
                  ']' +
                  '\n관리자에게 문의해 주세요. (1599-3518)',
              );
          }
      })
      .catch((error) => {
          this.resetUnlinkedRegistration();
          alert('서비스 요청 실패' + '\n관리자에게 문의해 주세요. (1599-3518)');
      }); 
  }

  // 네이버 커머스 선택 시 인스타그램 자동 관리(01014) 사용자 서비스를 먼저 신청합니다.
  saveNaverInstagramUserService = async () => {
    let data = {
      service_type: '01014',
      is_uninstall_yn: 'N'
    };
    const config = {
      headers: {
        'content-type': 'application/json;',
      },
    };

    try {
      const res = await http.post('/rest/shop/activeUserServiceSave', data, config);
      const result = res.data || {};
      if (result.code == "200") {
        return true;
      }

      alert(
        '[code : ' +
        result.code +
        ']' +
        '\n관리자에게 문의해 주세요. (1599-3518)',
      );
    } catch (error) {
      alert('서비스 요청 실패' + '\n관리자에게 문의해 주세요. (1599-3518)');
    }

    return false;
  }

  // 네이버 커머스솔루션마켓 진입. 실제 JWT는 네이버의 [신청하기]/[사용하기] 이후 callback URL로 전달됩니다.
  startNaverCommerceIntegration = () => {
    // 네이버 커머스 연동 시작도 지정된 테스트 세션에서만 허용합니다.
    if (!is_naver_commerce_test) {
      return;
    }

    var naverWindow = window.open('about:blank', '_blank');
    if (naverWindow == null) {
      alert('팝업이 차단되어 있습니다. 팝업 허용 후 다시 시도해 주세요.');
      return;
    }

    const serviceType = this.state.service_type || '';
    http
      .get('/rest/common/naver/solution/start?service_type=' + encodeURIComponent(serviceType))
      .then((res) => {
        const data = res.data || {};
        if (data.code == '200' && data.entry_url) {
          naverWindow.location = data.entry_url;
        } else {
          try { naverWindow.close(); } catch (e) {}
          alert(data.msg || '네이버 커머스 연동 URL을 확인할 수 없습니다.');
        }
      })
      .catch(() => {
        try { naverWindow.close(); } catch (e) {}
        alert('네이버 커머스 연동 준비 중 오류가 발생했습니다.\n관리자에게 문의해 주세요. (1599-3518)');
      });
  }

  handleNaverCommerceMessage = (event) => {
    if (event.origin != window.location.origin) {
      return;
    }
    const data = event.data || {};
    if (data.type == 'NAVER_COMMERCE_CONNECTED') {
      window.location.href = data.redirect_url || '/shop/serviceShopList';
    }
  }

  // Cafe24 로그인 팝업창 준비 (Safari 대응)
  async fn_asyncCall(g_oWindow, url) {
    g_oWindow.location = url;

    return true;
  }

  /**
   * [베타버전] 연동된 mall이 존재하는지 체크
   *  * 멀티샵만 지원하되 mall은 추가할 수 없다.
   *
   *  1. store 조회 (user_seq)
   *  2. 조회된 데이터에서 solution_type_cd 필드 체크.
   *  3. selectShops 조회
   */
  //사용자의 연동된 상점(store) 조회
  async selectStore() {
    is_stroe_loaded = true;
    // console.log("selectStore : [베타버전] 연동된 mall이 존재하는지 체크");
    const res = await http.get('/rest/common/selectStore');
    // 조회 성공시 다음 단계
    const requestedSolutionType = urlParams.get('solution_type_cd');
    const isNaverDirectAdd = requestedSolutionType == '09005' && is_naver_commerce_test;

    if (res.data != null && res.data.length > 0 && !isNaverDirectAdd) {
      // 기존 동작 유지: 이미 연동 상점이 있으면 목록으로 이동
      window.location.href = '/shop/serviceShopList';
    } else if (isNaverDirectAdd) {
      // 기존 상점이 있는 사용자도 명시적으로 09005 추가 URL로 진입한 경우 네이버 추가 화면을 허용합니다.
      this.setState({
        step: 2,
        solution_type_cd: '09005',
        solution_name: '네이버 커머스',
        show_platform_area: true,
      });
    } else {
      console.log("[selectStore] 연동된 상점 정보가 없습니다.");
      this.setState({
        step: 1,
      });
    }
  }

  //mall_id에 해당하는 shops 조회
  // async selectShops(mall_id, solution_type_cd) {
  //   const res = await http.get('/rest/common/selectShops', {
  //     params: {
  //       mall_id: mall_id,
  //       solution_type_cd: solution_type_cd,
  //     },
  //   });

  //   // 가입신청 - Cafe24 API] 상점 동기화
  //   //this.nextStep();
  //   // console.log("selectShops : mall_id에 해당하는 shops 조회");
  //   // console.log(res.data);

  //   // 조회 성공시 다음 단계
  //   if (res.data != null && res.data.length > 0) {
  //     /**
  //      * V2 : /shop/serviceShopAdd로 이동
  //      */
  //     alert('연동된 쇼핑몰 정보가 없습니다.\n해당 플랫폼의 쇼핑몰 정보를 확인해 주세요.');
  //   } else {
  //     alert('연동된 쇼핑몰 정보가 없습니다.\n해당 플랫폼의 쇼핑몰 정보를 확인해 주세요.');
  //     this.setState({
  //       step: 1,
  //       mall_id: '',
  //     });
  //   }
  // }

  // input text change event
  handleText = (e, key) => {
    // computed property
    //this.setState({[key]: e.target.value});
    if (key == 'mall_id') {
      this.setState({ mall_id: e.target.value });
    }
  };

  // 메이크샵 input text change event
  makeshop_handleText = (e, key) => {
    const { makeshop } = this.state;
    this.setState({
      makeshop: {
        ...makeshop,
        [key]: e.target.value,
      },
    });
  };

  // 아임웹 input text change event
  imweb_handleText = (e, key) => {
    const { imweb } = this.state;
    this.setState({
      imweb: {
        ...imweb,
        [key]: e.target.value,
      },
    });
  };

  // 고도몰 input text change event
  godomall_handleText = (e, key) => {
    const { godomall } = this.state;
    this.setState({
      godomall: {
        ...godomall,
        [key]: e.target.value,
      },
    });
  };

  // 언어코드 변경 이벤트
  onChangeSelectBoxlanguageCodeHandler = (e, mode) => {
    if (mode == 'makeshop') {
      const { makeshop } = this.state;
      this.setState({
        makeshop: {
          ...makeshop,
          language_code: e.target.value,
        },
      });
    } else if (mode == 'imweb') {
      const { imweb } = this.state;
      this.setState({
        imweb: {
          ...imweb,
          language_code: e.target.value,
        },
      });
    } else if (mode == 'godomall') {
      const { godomall } = this.state;
      this.setState({
        godomall: {
          ...godomall,
          language_code: e.target.value,
        },
      });
    }
  };

  platformImg(solution_type_cd) {
    const { support_solution } = this.state.options
    const idx = support_solution.findIndex((solution) => solution.code_cd == solution_type_cd)
    let img_url = "";
    
    if (idx >= 0) {
      img_url = support_solution[idx].val2;
    }

    return img_url;
  }

  componentDidUpdate() {
    var params = {};
    window.location.search.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (str, key, value) {
        params[key] = value;
      },
    );
    if (this.state.step != '0') {
      // alert(is_stroe_loaded);
      if (!is_stroe_loaded) {
        this.selectStore(); // 상점 추가
      }
    }
  }

  componentDidMount() {
    window.addEventListener('message', this.handleNaverCommerceMessage);

    //쇼핑몰 플랫폼 코드 조회
    this.getCode('09000', 'support_solution');
    //언어 코드 조회 (현재 고정)
    //this.getCode("09000", "language_code_list");

    /**
     * [베타버전] 연동된 mall이 존재하는지 체크
     *  * 멀티샵만 지원하되 mall은 추가할 수 없다.
     *
     *  1. store 조회 (user_seq)
     *  2. 조회된 데이터에서 solution_type_cd 필드 체크.
     *  3. selectShops 조회
     */
    var params = {};
    window.location.search.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (str, key, value) {
        params[key] = value;
      },
    );
    // 로그인 사용자의 연동된 상점 조회
    this.selectStore();
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleNaverCommerceMessage);
  }

  selectSolutionByCode = async (code_cd, code_name, is_next_step) => {
    // 일반 사용자에게는 네이버 커머스 선택을 허용하지 않습니다.
    if (code_cd == '09005' && !is_naver_commerce_test) {
      return;
    }

    // 네이버 커머스는 인스타그램 자동 관리(01014) 서비스만 사용합니다.
    if (code_cd == '09005' && this.state.service_type != '01014') {
      const result = await this.openConfirmDialog({
        title: '네이버 커머스 서비스 안내',
        content: 'AI 인스타그램 자동관리 서비스만 사용 가능합니다.<br/>AI 인스타그램 자동관리 서비스를 신청 하시겠습니까?',
      });

      if (!result) {
        return;
      }

      const isSaved = await this.saveNaverInstagramUserService();
      if (!isSaved) {
        return;
      }

      this.setState({
        service_type: '01014',
        solution_type_cd: code_cd,
        solution_name: code_name,
        show_platform_area: true,
      }, () => {
        if (is_next_step === true) {
          this.nextStep();
        }
      });
      return;
    }

    this.setState({
      solution_type_cd: code_cd,
      solution_name: code_name,
      show_platform_area: code_cd != '09900',
    }, () => {
      if (is_next_step === true) {
        this.nextStep();
      }
    });
  }

  backToSolutionSelect = (e) => {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      step: 1,
      agree_yn: '',
    });
  }

  openUserGuide = (e, url) => {
    if (e) {
      e.preventDefault();
    }

    Menu.call_userGuide(url);
  }

  getSolutionByCode = (code_cd) => {
    const { support_solution } = this.state.options;
    return support_solution.find((solution) => solution.code_cd == code_cd);
  }

  getPlatformLogoClass = (code_cd) => {
    if (code_cd == '09001') return 'logo-cafe24';
    if (code_cd == '09002') return 'logo-makeshop';
    if (code_cd == '09003') return 'logo-imweb';
    if (code_cd == '09004') return 'logo-godomall';
    if (code_cd == '09005') return 'logo-naver-commerce';
    return '';
  }

  getGuideUrl = (solution_type_cd) => {
    if (solution_type_cd == '09001') return 'https://iclave.notion.site/24-db0f5f49d484468eb7b38bc2983a9e7d';
    if (solution_type_cd == '09002') return 'https://iclave.notion.site/c3deef5fe8cb404fad56ecb006aec3fe';
    if (solution_type_cd == '09003') return 'https://iclave.notion.site/fe1a130d593f4ef991138f99afde4066';
    if (solution_type_cd == '09004') return 'https://iclave.notion.site/3b52245dbcfb4892830c732b539605e4';
    return '';
  }

  getIntegrationDescription = (solution_type_cd) => {
    if (solution_type_cd == '09001') return '쇼핑몰 데이터를 불러오기 위해 카페24 ID를 입력해 주세요.';
    if (solution_type_cd == '09002') return '메이크샵 연동을 위한 정보를 입력해 주세요.';
    if (solution_type_cd == '09003') return '아임웹 연동을 위한 정보를 입력해 주세요.';
    if (solution_type_cd == '09004') return '고도몰 연동을 위한 정보를 입력해 주세요.';
    if (solution_type_cd == '09005') return '네이버 커머스솔루션마켓에서 판매자 인증 후 스마트스토어를 연결합니다.';
    return '쇼핑몰 연동을 위한 정보를 입력해 주세요.';
  }

  isAgreementChecked = () => {
    return this.state.agree_yn == 'Y';
  }

  renderBackIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="19" y1="12" x2="5" y2="12"></line>
      <polyline points="12 19 5 12 12 5"></polyline>
    </svg>
  )

  renderLanguageOptions = () => (
    <>
      <option value="" disabled>언어 코드를 선택해 주세요.</option>
      {this.state.options.language_code_list.map((option, idx) => (
        <option key={idx} value={option.cd_code}>
          {option.cd_desc}
        </option>
      ))}
    </>
  )

  renderInputGroup = (id, label, value, onChange, placeholder, required) => (
    <div className="input-group">
      <label htmlFor={id} className="input-label">
        {label}
        {required === true ? <span className="required">*</span> : ''}
      </label>
      <input
        id={id}
        className="custom-input"
        type="text"
        value={value}
        onChange={onChange}
        onBlur={id == 'cafe24Id' ? this.handleMallIdOnBlur : undefined}
        placeholder={placeholder || '필수 입력 사항입니다.'}
        required={required}
      />
    </div>
  )

  renderLanguageSelect = (id, value, mode) => (
    <div className="input-group">
      <label htmlFor={id} className="input-label">언어 코드</label>
      <select
        id={id}
        className="custom-select"
        value={value}
        onChange={(e) => this.onChangeSelectBoxlanguageCodeHandler(e, mode)}
      >
        {this.renderLanguageOptions()}
      </select>
    </div>
  )

  renderConsent = () => (
    <div className="consent-group">
      <label className="checkbox-label">
        <input
          type="checkbox"
          checked={this.isAgreementChecked()}
          onChange={(e) => this.onClickAgree(e, e.target.checked ? 'Y' : 'N')}
        />
        <span>계정 정보 확인 및 데이터 연동에 동의합니다.</span>
      </label>
    </div>
  )

  renderPlatformLogo = (solution) => {
    if (solution.val3 != null && solution.val3 != '') {
      return <img src={solution.val3} alt={solution.code_name} />;
    }

    if (solution.code_cd == '09001') {
      return <>cafe<span>24</span></>;
    }

    if (solution.code_cd == '09002') {
      return <>Make<span>Shop</span></>;
    }

    if (solution.code_cd == '09003') {
      return <>I'mweb</>;
    }

    if (solution.code_cd == '09004') {
      return <>godomall</>;
    }

    if (solution.code_cd == '09005') {
      return <>NAVER</>;
    }

    return solution.code_name;
  }

  renderSolutionSelectPanel = () => {
    const { support_solution } = this.state.options;
    const linkedSolutions = support_solution.filter((solution) => solution.code_cd != '09900');
    const noMallSolution = support_solution.find((solution) => solution.code_cd == '09900');
    const isGeneralActive = this.state.solution_type_cd == '09900';
    const isMallActive = this.state.show_platform_area === true || (this.state.solution_type_cd != '' && this.state.solution_type_cd != '09900');

    return (
      <div className="onboarding-panel">
        <div className="panel-header">
          <h2>로보MD에 오신 것을 환영합니다!</h2>
          <p>가장 알맞은 AI 업무 환경을 준비해 드릴게요. 운영 중이신 비즈니스 유형을 선택해 주세요.</p>
        </div>

        <div className="cards-wrapper">
          <div
            className={isGeneralActive ? 'type-card active' : 'type-card'}
            onClick={() => {
              if (noMallSolution != null) {
                // 카드를 선택하고, 실제 서비스 등록은 카드 안의 시작하기 버튼에서 실행합니다.
                this.selectSolutionByCode(noMallSolution.code_cd, noMallSolution.code_name, false);
              }
            }}
          >
            <div className="icon-box general">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M3 21h18M5 21V5a2 2 0 012-2h10a2 2 0 012 2v16M9 9h6M9 13h6M9 17h6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="card-title">일반 비즈니스 / 개인</div>
            <div className="card-desc">서비스, 중소기업, 예비창업자, 오픈마켓, 매장 등</div>
            {noMallSolution != null ? (
              <button
                type="button"
                className="general-action-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  this.selectSolutionByCode(noMallSolution.code_cd, noMallSolution.code_name, true);
                }}
                disabled={this.state.is_registering_unlinked}
              >
                시작하기
              </button>
            ) : null}
          </div>

          <div
            className={isMallActive ? 'type-card active' : 'type-card'}
            onClick={() => this.setState({ show_platform_area: true, solution_type_cd: '', solution_name: '' })}
          >
            <div className="icon-box mall">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="card-title">쇼핑몰 운영자</div>
            <div className="card-desc">
              {is_naver_commerce_test
                ? '카페24, 메이크샵, 아임웹, 고도몰, 네이버 커머스 등'
                : '카페24, 메이크샵, 아임웹, 고도몰 등'}
            </div>
          </div>
        </div>

        <div className={isMallActive ? 'platform-area show' : 'platform-area'}>
          <h3>이용 중인 쇼핑몰 솔루션을 선택해 주세요.</h3>
          <div className="platform-grid">
            {linkedSolutions.map((solution, index) => (
              <div
                key={index}
                className={
                  this.state.solution_type_cd == solution.code_cd
                    ? 'platform-logo-card active ' + this.getPlatformLogoClass(solution.code_cd)
                    : 'platform-logo-card ' + this.getPlatformLogoClass(solution.code_cd)
                }
                onClick={() => this.selectSolutionByCode(solution.code_cd, solution.code_name, true)}
              >
                {this.renderPlatformLogo(solution)}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  renderCafe24Form = () => (
    <>
      {this.renderInputGroup(
        'cafe24Id',
        '카페24 쇼핑몰 ID',
        this.state.mall_id,
        (e) => this.handleText(e, 'mall_id'),
        '필수 입력 사항입니다.',
        true,
      )}
    </>
  )

  renderMakeshopForm = () => (
    <>
      {this.renderInputGroup('shopKey', 'SHOP KEY', this.state.makeshop.shop_key, (e) => this.makeshop_handleText(e, 'shop_key'), '필수 입력 사항입니다.', true)}
      {this.renderInputGroup('makeshopDomain', '도메인', this.state.makeshop.domain, (e) => this.makeshop_handleText(e, 'domain'), '필수 입력 사항입니다.', true)}
      {this.renderInputGroup('makeshopShopName', '쇼핑몰 이름', this.state.makeshop.shop_name, (e) => this.makeshop_handleText(e, 'shop_name'), '필수 입력 사항입니다.', true)}
      {this.renderLanguageSelect('makeshopLangCode', this.state.makeshop.language_code, 'makeshop')}
    </>
  )

  renderImwebForm = () => (
    <>
      {this.renderInputGroup('imwebApiKey', 'API KEY', this.state.imweb.api_key, (e) => this.imweb_handleText(e, 'api_key'), '필수 입력 사항입니다.', true)}
      {this.renderInputGroup('imwebSecretKey', 'SECRET KEY', this.state.imweb.secret_key, (e) => this.imweb_handleText(e, 'secret_key'), '필수 입력 사항입니다.', true)}
      {this.renderInputGroup('imwebDomain', '도메인', this.state.imweb.domain, (e) => this.imweb_handleText(e, 'domain'), '필수 입력 사항입니다.', true)}
      {this.renderInputGroup('imwebShopName', '쇼핑몰 이름', this.state.imweb.shop_name, (e) => this.imweb_handleText(e, 'shop_name'), '필수 입력 사항입니다.', true)}
      {this.renderLanguageSelect('imwebLangCode', this.state.imweb.language_code, 'imweb')}
    </>
  )

  renderGodomallForm = () => (
    <>
      {this.renderInputGroup('godoId', '고도몰 ID (nhn-commerce.com 계정)', this.state.godomall.id, (e) => this.godomall_handleText(e, 'id'), '필수 입력 사항입니다.', true)}
      {this.renderInputGroup('godomallDomain', '도메인', this.state.godomall.domain, (e) => this.godomall_handleText(e, 'domain'), '필수 입력 사항입니다.', true)}
      {this.renderInputGroup('godomallShopName', '쇼핑몰 이름', this.state.godomall.shop_name, (e) => this.godomall_handleText(e, 'shop_name'), '필수 입력 사항입니다.', true)}
      {this.renderLanguageSelect('godomallLangCode', this.state.godomall.language_code, 'godomall')}
    </>
  )

  renderNaverCommerceForm = () => (
    <div className="naver-commerce-guide">
      <strong>네이버 판매자 인증으로 연결합니다.</strong>
      <p>아래 버튼을 누르면 네이버 커머스솔루션마켓으로 이동합니다. 네이버에서 로보MD의 신청하기/사용하기를 진행하면 인증 정보가 자동으로 전달됩니다.</p>
      <p>네이버 계정 UID와 채널 번호는 별도로 보관되며, 로보MD 내부 쇼핑몰 번호는 네이버 채널 번호와 분리하여 관리합니다.</p>
    </div>
  )

  renderIntegrationFields = () => {
    if (this.state.solution_type_cd == '09001') return this.renderCafe24Form();
    if (this.state.solution_type_cd == '09002') return this.renderMakeshopForm();
    if (this.state.solution_type_cd == '09003') return this.renderImwebForm();
    if (this.state.solution_type_cd == '09004') return this.renderGodomallForm();
    if (this.state.solution_type_cd == '09005') return this.renderNaverCommerceForm();
    return '';
  }

  getIntegrationMode = () => {
    if (this.state.solution_type_cd == '09001') return '/cafe24_sync_data';
    if (this.state.solution_type_cd == '09002') return 'makeshop';
    if (this.state.solution_type_cd == '09003') return 'imweb';
    if (this.state.solution_type_cd == '09004') return 'godomall';
    if (this.state.solution_type_cd == '09005') return 'naver_commerce';
    return '';
  }

  openConfirmDialog(props) {
    return new Promise((resolve) => {
      const container = document.createElement("div");
      document.body.appendChild(container);

      const close = (result) => {
        resolve(result);
        ReactDOM.unmountComponentAtNode(container);
        container.remove();
      };

      ReactDOM.render(
        <TitleContentDialogV2
          {...props}
          popup_close={() => close(false)}
          button_list={[
            {
              title: "확인",
              event_method: () => close(true),
            },
            {
              title: "취소",
              event_method: () => close(false),
            },
          ]}
        />,
        container
      );
    });
  }

  renderIntegrationPanel = () => {
    const guideUrl = this.getGuideUrl(this.state.solution_type_cd);
    const mode = this.getIntegrationMode();

    return (
      <div className="form-panel">
        <a href="#" className="back-btn" onClick={this.backToSolutionSelect} aria-label="이전 화면으로 돌아가기">
          {this.renderBackIcon()}
        </a>

        <div className="panel-header">
          <h2>쇼핑몰 데이터 불러오기</h2>
          <p>{this.getIntegrationDescription(this.state.solution_type_cd)}</p>
          {guideUrl != '' ? (
            <a href="#" className="guide-btn" onClick={(e) => this.openUserGuide(e, guideUrl)}>
              사용자 가이드 보기
            </a>
          ) : ''}
        </div>

        <form
          id="integrationForm"
          onSubmit={(e) => {
            e.preventDefault();
            this.onClickGetStoreInfoButton(mode);
          }}
        >
          {this.renderIntegrationFields()}
          {this.renderConsent()}

          <button type="submit" id="submitBtn" className="submit-btn" disabled={!this.isAgreementChecked()}>
            {this.state.solution_type_cd == '09005' ? '네이버 커머스 연동하기' : '쇼핑몰 데이터 불러오기'}
          </button>
        </form>
      </div>
    );
  }

  renderLoadingPanel = () => (
    <div className="form-panel">
      <div className="panel-header">
        <h2>쇼핑몰 데이터 불러오기</h2>
        <p>연동 상태를 확인하고 있습니다.</p>
      </div>
    </div>
  )

  renderSolutionStoreStyle = () => (
    <style>{`
      .solution-store-add {
        width: 100%;
        max-width: 100% !important;
        min-height: 100vh;
        padding: 40px 20px;
        background-color: #f4f5f7;
        color: #333;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, system-ui, Roboto, sans-serif;
        box-sizing: border-box;
        padding: 72px 0 0 220px !important;
      }

      .solution-store-add *,
      .solution-store-add *::before,
      .solution-store-add *::after {
        box-sizing: border-box;
      }

      .solution-store-add .onboarding-panel {
        width: 100%;
        max-width: 1200px;
        background: #ffffff;
        padding: 80px 60px;
        border-radius: 20px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
        text-align: center;
        transition: all 0.3s ease;
      }

      .solution-store-add .form-panel {
        width: 100%;
        max-width: 600px;
        background: #ffffff;
        padding: 50px 40px;
        border-radius: 20px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
        position: relative;
      }

      .solution-store-add .back-btn {
        position: absolute;
        top: 30px;
        left: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #f9fafb;
        border: 1px solid #e5e7eb;
        color: #666;
        cursor: pointer;
        transition: all 0.2s;
        text-decoration: none;
      }

      .solution-store-add .back-btn:hover {
        background-color: #f3f4f6;
        color: #111;
        border-color: #d1d5db;
      }

      .solution-store-add .panel-header {
        margin-top: 10px;
        margin-bottom: 40px;
        text-align: center;
      }

      .solution-store-add .onboarding-panel .panel-header {
        margin-top: 0;
        margin-bottom: 0;
      }

      .solution-store-add .panel-header h2 {
        font-size: 26px;
        font-weight: 700;
        color: #111;
        margin: 0 0 12px;
        letter-spacing: -0.5px;
      }

      .solution-store-add .onboarding-panel .panel-header h2 {
        font-size: 32px;
        margin-bottom: 16px;
      }

      .solution-store-add .panel-header p {
        font-size: 15px;
        color: #666;
        margin: 0 0 16px;
        line-height: 1.5;
        word-break: keep-all;
      }

      .solution-store-add .onboarding-panel .panel-header p {
        font-size: 18px;
        margin-bottom: 60px;
      }

      .solution-store-add .guide-btn {
        display: inline-block;
        padding: 6px 14px;
        font-size: 13px;
        font-weight: 600;
        color: #00d4d4;
        background-color: #f0fdfd;
        border: 1px solid #00d4d4;
        border-radius: 20px;
        text-decoration: none;
        transition: all 0.2s;
      }

      .solution-store-add .guide-btn:hover {
        background-color: #00d4d4;
        color: #ffffff;
      }

      .solution-store-add .cards-wrapper {
        display: flex;
        gap: 32px;
        justify-content: center;
      }

      .solution-store-add .type-card {
        flex: 1;
        max-width: 500px;
        padding: 60px 40px;
        background-color: #ffffff;
        border: 2px solid #e5e7eb;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        transition: all 0.2s ease;
      }

      .solution-store-add .type-card:hover {
        border-color: #00d4d4;
        background-color: #faffff;
        transform: translateY(-6px);
        box-shadow: 0 16px 32px rgba(0, 212, 212, 0.08);
      }

      .solution-store-add .type-card.active {
        border-color: #00d4d4;
        background-color: #faffff;
        box-shadow: 0 0 0 4px rgba(0, 212, 212, 0.1);
      }

      .solution-store-add .icon-box {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 24px;
      }

      .solution-store-add .icon-box.general {
        background-color: #e0f8f8;
        color: #00a8a8;
      }

      .solution-store-add .icon-box.mall {
        background-color: #fff0e6;
        color: #ff7a00;
      }

      .solution-store-add .icon-box svg {
        width: 48px;
        height: 48px;
        stroke-width: 1.5;
      }

      .solution-store-add .card-title {
        font-size: 24px;
        font-weight: 700;
        color: #222;
        margin-bottom: 12px;
      }

      .solution-store-add .card-desc {
        font-size: 16px;
        color: #777;
        line-height: 1.5;
      }

      .solution-store-add .general-action-btn {
        width: 70%;
        max-width: 320px;
        min-width: 140px;
        margin-top: 24px;
        padding: 16px 28px;
        border: 0;
        border-radius: 10px;
        background-color: #00e2e6;
        color: #0A1A2F;
        font-size: 16px;
        font-weight: 700;
        cursor: pointer;
        transition: background-color 0.2s;
        box-shadow: 0 2px 8px rgba(0, 226, 230, 0.2);
      }

      .solution-store-add .general-action-btn:hover {
        background-color: #00bfc2;
        transform: translateY(-1px);
      }

      .solution-store-add .general-action-btn:disabled {
        cursor: not-allowed;
        opacity: 0.65;
      }


      .solution-store-add .platform-area {
        max-height: 0;
        opacity: 0;
        overflow: hidden;
        transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      }

      .solution-store-add .platform-area.show {
        max-height: 400px;
        opacity: 1;
        margin-top: 60px;
        padding-top: 50px;
        border-top: 1px solid #e5e7eb;
      }

      .solution-store-add .platform-area h3 {
        font-size: 20px;
        font-weight: 600;
        color: #333;
        margin: 0 0 30px;
      }

      .solution-store-add .platform-grid {
        display: flex;
        gap: 20px;
        justify-content: center;
        flex-wrap: wrap;
      }

      .solution-store-add .platform-logo-card {
        width: 200px;
        height: 90px;
        background-color: #fff;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: all 0.2s ease;
        font-size: 22px;
        font-weight: 700;
        letter-spacing: -0.5px;
        overflow: hidden;
      }

      .solution-store-add .platform-logo-card:hover,
      .solution-store-add .platform-logo-card.active {
        border-color: #00d4d4;
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.05);
        transform: translateY(-3px);
      }

      .solution-store-add .platform-logo-card img {
        max-width: 80%;
        max-height: 54px;
        object-fit: contain;
        pointer-events: none;
      }

      .solution-store-add .logo-cafe24 {
        color: #000;
      }

      .solution-store-add .logo-cafe24 span {
        color: #005AAB;
      }

      .solution-store-add .logo-makeshop {
        color: #005AAB;
      }

      .solution-store-add .logo-naver-commerce {
        color: #03c75a;
        font-weight: 800;
        letter-spacing: -1px;
      }

      .solution-store-add .naver-commerce-guide {
        margin-bottom: 20px;
        padding: 18px 20px;
        border: 1px solid #e7e9ed;
        border-radius: 12px;
        background: #f8faf9;
        line-height: 1.7;
      }

      .solution-store-add .naver-commerce-guide strong {
        display: block;
        margin-bottom: 8px;
        color: #111;
      }

      .solution-store-add .naver-commerce-guide p {
        margin: 4px 0;
        color: #555;
      }

      .solution-store-add .logo-makeshop span {
        color: #333;
      }

      .solution-store-add .logo-imweb {
        color: #0055FF;
        font-style: italic;
      }

      .solution-store-add .logo-godomall {
        color: #E50014;
      }

      .solution-store-add .input-group {
        display: block;
        width: 100%;
        margin-bottom: 24px;
        text-align: left;
      }

      .solution-store-add .input-label {
        display: block;
        font-size: 14px;
        font-weight: 600;
        color: #333;
        margin-bottom: 8px;
      }

      .solution-store-add .input-label span.required {
        color: #ff4d4f;
        margin-left: 4px;
      }

      .solution-store-add .custom-input,
      .solution-store-add .custom-select {
        width: 100%;
        height: auto;
        padding: 14px 16px;
        font-size: 15px;
        color: #333;
        border: 1px solid #d1d5db;
        border-radius: 8px;
        background-color: #fff;
        outline: none;
        transition: border-color 0.2s, box-shadow 0.2s;
        box-shadow: none;
      }

      .solution-store-add .custom-input::placeholder {
        color: #aaa;
      }

      .solution-store-add .custom-input:focus,
      .solution-store-add .custom-select:focus {
        border-color: #00d4d4;
        box-shadow: 0 0 0 3px rgba(0, 212, 212, 0.1);
      }

      .solution-store-add .custom-select {
        appearance: none;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 16px;
        cursor: pointer;
      }

      .solution-store-add .consent-group {
        margin-top: 40px;
        margin-bottom: 24px;
        padding: 20px;
        background-color: #f9fafb;
        border-radius: 12px;
        border: 1px solid #e5e7eb;
        display: flex;
        justify-content: center;
      }

      .solution-store-add .checkbox-label {
        display: flex;
        align-items: center;
        cursor: pointer;
        font-size: 15px;
        color: #444;
        font-weight: 500;
        margin: 0;
      }

      .solution-store-add input[type="checkbox"] {
        display: block;
      }
      .solution-store-add .checkbox-label input[type="checkbox"] {
        appearance: none;
        width: 22px;
        height: 22px;
        border: 2px solid #ccc;
        border-radius: 6px;
        margin: 0 12px 0 0;
        cursor: pointer;
        position: relative;
        transition: all 0.2s;
        flex: 0 0 auto;
      }

      .solution-store-add .checkbox-label input[type="checkbox"]:checked {
        background-color: #00d4d4;
        border-color: #00d4d4;
      }

      .solution-store-add .checkbox-label input[type="checkbox"]:checked::after {
        content: '';
        position: absolute;
        top: 3px;
        left: 7px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }

      .solution-store-add .submit-btn {
        width: 100%;
        padding: 18px;
        font-size: 16px;
        font-weight: 700;
        color: #ffffff;
        background-color: #00d4d4;
        border: none;
        border-radius: 10px;
        cursor: pointer;
        transition: background-color 0.2s;
      }

      .solution-store-add .submit-btn:hover {
        background-color: #00baba;
      }

      .solution-store-add .submit-btn:disabled {
        background-color: #e5e7eb;
        color: #9ca3af;
        cursor: not-allowed;
      }

      @media (max-width: 992px) {
        .solution-store-add .onboarding-panel {
          padding: 60px 40px;
        }

        .solution-store-add .cards-wrapper {
          flex-direction: column;
          align-items: center;
        }

        .solution-store-add .type-card {
          width: 100%;
          max-width: 600px;
          padding: 40px 30px;
        }
      }

      @media (max-width: 800px) {
        #page-wrapper {
          padding-bottom: 130px !important;
        }

        .solution-store-add {
          min-height: calc(100vh - 64px);
        }

        .solution-store-add .onboarding-panel,
        .solution-store-add .form-panel {
          border-radius: 16px;
        }

        .solution-store-add .onboarding-panel {
          padding: 40px 24px;
        }

        .solution-store-add .form-panel {
          padding: 40px 24px;
        }

        .solution-store-add .back-btn {
          top: 20px;
          left: 20px;
        }

        .solution-store-add .form-panel .panel-header {
          margin-top: 30px;
        }

        .solution-store-add .platform-logo-card {
          width: calc(50% - 10px);
          height: 80px;
          font-size: 18px;
        }
      }
    `}</style>
  )

  render() {
    $('.pageName').text('쇼핑몰 데이터 불러오기');
    return (
      <>
        <div id="page-wrapper" className="solution-store-add">
          {this.renderSolutionStoreStyle()}
          {this.state.step == 1 ? this.renderSolutionSelectPanel() : ''}
          {this.state.step == 2 ? this.renderIntegrationPanel() : ''}
          {this.state.step != 1 && this.state.step != 2 ? this.renderLoadingPanel() : ''}
        </div>
        {/* 등록 중 로딩: SaveDialogV2의 숨김 버튼 설정으로 기본 로딩 프로그레스를 표시합니다. */}
        {this.state.is_registering_unlinked && (
          <SaveDialogV2
            content={"서비스를 준비하고 있습니다.<br/>설정이 완료되면 자동으로 이동합니다."}
            button_list={[{ title: "확인", type: "1", display_yn: "N" }]}
          />
        )}
        {/* 진열여부 설정 팝업 
          1. popup_id : "common_popup1"		(div id 부여)
          2. width : "450px" 					(최소 450px)
          3. content : "팝업 내용<br/>예제 입니다."
          4. button_list : 
            [
              {
                title: "버튼명",			  // 버튼명
                type: "1",					// 버튼 (컬러)타입 : "1" (#10CFC9), "0" (#FFFFFF) 
                event_method: () => {
                  //이벤트 함수 구현
                  ...
                }
              },
            ]
          5. button_close : 닫기 함수 구현
        */}
        {
          (this.state.common_popup1 === true)
          ? <CommonPopup 
            popup_id={"common_popup1"}
            width={"465px"}
            content={this.state.common_popup1_content}
            button_list={this.state.common_popup1_button_list}
            popup_close={() => this.setState({common_popup1: false})}
          />
          : ''
        }
        {this.state.warning_dialog_show_state && <WarningDialog content={this.state.warning_dialog_content} button_list={this.state.warning_dialog_button_list} />}
      </>
    );
  }
}